module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921055649_T.b88e85ac.jpg";